export default function scTracking(event, params) {
  if (!event) return false;

  var url = "";

  switch (event) {
    case "share":
      url = "/api/tracking/share";
      break;
    case "socialfollow":
      url = "/api/tracking/socialfollow";
      break;
    case "download":
      url = "/api/tracking/download";
      break;
    case "videoplay":
      url = "/api/tracking/videoplay";
      break;
    case "interstitialtriggered":
      url = "/api/tracking/interstitialtriggered";
      break;
    case "email1":
      url = `/api/tracking/email?email=${params.email}&goalId=${params.goal}`;
      break;
    case "email2":
      url = "/api/tracking/email?goalId=" + params.goal;
      break;
    default:
      return false;
  }

  fetch(url, {
    method: "GET",
    credentials: "same-origin",
  })
    .then((response) => {
      return;
    })
    .catch((error) => {
      console.error("SC Tracking Error: ", error);
    });
}
